module.exports = __webpack_public_path__ + "static/media/landing_page.2d8e8d85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assests/images/landing_page.jpg
// module id = 155
// module chunks = 3